/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1TutoraiDocumentsDocumentid202,
  DeleteApiV1TutoraiDocumentsDocumentid401,
  DeleteApiV1TutoraiDocumentsDocumentid404,
  DeleteApiV1TutoraiDocumentsDocumentid500,
  DeleteApiV1TutoraiDocumentsDocumentidMutationResponse,
  DeleteApiV1TutoraiDocumentsDocumentidPathParams,
} from "../../types/tutorAIDocumentosController/DeleteApiV1TutoraiDocumentsDocumentid.ts";

export const deleteApiV1TutoraiDocumentsDocumentidPathParamsSchema = z.object({
  documentId: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1TutoraiDocumentsDocumentidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1TutoraiDocumentsDocumentid202Schema =
  z.any() as unknown as ToZod<DeleteApiV1TutoraiDocumentsDocumentid202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1TutoraiDocumentsDocumentid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1TutoraiDocumentsDocumentid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1TutoraiDocumentsDocumentid404Schema =
  z.any() as unknown as ToZod<DeleteApiV1TutoraiDocumentsDocumentid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1TutoraiDocumentsDocumentid500Schema =
  z.any() as unknown as ToZod<DeleteApiV1TutoraiDocumentsDocumentid500>;

export const deleteApiV1TutoraiDocumentsDocumentidMutationResponseSchema =
  z.lazy(
    () => deleteApiV1TutoraiDocumentsDocumentid202Schema,
  ) as unknown as ToZod<DeleteApiV1TutoraiDocumentsDocumentidMutationResponse>;
